import { RecurringInvoice } from "@wingspanhq/wingspan-api-sdk";

export const selectorIsTopLevelRecurringInvoice = (
  recurringInvoice: RecurringInvoice
): boolean => !recurringInvoice.metadata?.parentInvoiceTemplateId;
